module.exports = __webpack_public_path__ + "img/244.1241d688.jpg";